import { render, staticRenderFns } from "./recibo-pagamento-empresas-nota-credito.vue?vue&type=template&id=2ab3c69b&scoped=true&"
import script from "./recibo-pagamento-empresas-nota-credito.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-empresas-nota-credito.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-empresas-nota-credito.vue?vue&type=style&index=0&id=2ab3c69b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3c69b",
  null
  
)

export default component.exports